import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ProvedorConfirmacao } from "./componentes/Confirmacao";
import { ProvedorAvisos } from "./componentes/ui";
import { ErroRequisicao } from "./lib/api";
import { CHAVE_EU } from "./lib/sessao";
import { aplicarAparencia } from "./lib/tema";
import { roteador } from "./roteador";
import "./estilos.css";

// Antes do primeiro desenho, para não piscar no tema errado.
aplicarAparencia();


// Qualquer 401 (sessão expirada, encerrada em outro aparelho) volta para a tela de entrada.
const aoErrar = (erro: Error) => {
  // Só "não autenticado": senha ou código 2FA errado também é 401 e não deve derrubar a tela.
  if (erro instanceof ErroRequisicao && erro.corpo.erro === "nao_autenticado") clienteConsultas.setQueryData(CHAVE_EU, null);
  if (erro instanceof ErroRequisicao && erro.status === 403 && erro.corpo.erro === "sessao_incompleta") {
    void clienteConsultas.invalidateQueries({ queryKey: CHAVE_EU });
  }
};

const clienteConsultas: QueryClient = new QueryClient({
  queryCache: new QueryCache({ onError: aoErrar }),
  mutationCache: new MutationCache({ onError: aoErrar }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Erros 4xx não melhoram com nova tentativa; falha de rede (status 0) e 5xx tentam de novo.
      retry: (tentativas, erro) => !(erro instanceof ErroRequisicao && erro.status >= 400 && erro.status < 500) && tentativas < 2,
    },
  },
});

createRoot(document.getElementById("raiz")!).render(
  <StrictMode>
    <QueryClientProvider client={clienteConsultas}>
      <ProvedorAvisos>
        <ProvedorConfirmacao>
          <RouterProvider router={roteador} />
        </ProvedorConfirmacao>
      </ProvedorAvisos>
    </QueryClientProvider>
  </StrictMode>,
);
